import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from '../locales/zh'
import en from '../locales/en'

Vue.use(VueI18n)

const messages = {
  zh,
  en
}

// 从localStorage获取保存的语言设置，默认为中文
const savedLanguage = localStorage.getItem('language') || 'zh'

const i18n = new VueI18n({
  locale: savedLanguage,
  fallbackLocale: 'zh',
  messages
})

export default i18n
